/**
 * The neutral organisation logo (a building glyph on a slate tile, no text):
 * what e-mail to a tenant's people carries when neither the workspace nor the
 * company has uploaded one — never HumanFirewall's (owner, 2026-10-08). The API
 * links the same file on each instance's FRONTEND_URL
 * (apps/api/src/common/branding/generic-org-logo.ts); it is served from this
 * frontend's cookie-free /brand/ path, so a screen can show it as the
 * placeholder for "no logo yet".
 */
export const GENERIC_ORG_LOGO_PATH = '/brand/email-icons/generic-org-logo.png'
